import { render, staticRenderFns } from "./UserPersonalization.vue?vue&type=template&id=36f6ba94&"
import script from "./UserPersonalization.vue?vue&type=script&lang=js&"
export * from "./UserPersonalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports